import { merge } from 'lodash'
import { taskCategoryType, TYPES as TASK_CATEGORY_TYPE_TYPES } from './task-category-type/store'
import { taskCategory, TYPES as TASK_CATEGORY_TYPES } from './task-category/store'
import { taskPriority, TYPES as TASK_PRIORITY_TYPES } from './task-priority/store'
import { taskState, TYPES as TASK_STATE_TYPES } from './task-state/store'
import { task, TYPES as TASK_TYPES } from './task/store'
import { taskTag, TYPES as TASK_TAG_TYPES } from './task-tag/store'
import { taskComment, TYPES as TASK_COMMENT_TYPES } from './task-comment/store'

const store = {
  GENERIC: {
    namespaced: true,
    modules: {
      task: {
        namespaced: true,
        modules: {
          'task-category-type': taskCategoryType,
          'task-category': taskCategory,
          'task-priority': taskPriority,
          'task-state': taskState,
          task,
          'task-tag': taskTag,
          'task-comment': taskComment
        }
      }
    }
  }
}

const TYPES = () =>
  merge(
    TASK_CATEGORY_TYPE_TYPES,
    TASK_CATEGORY_TYPES,
    TASK_PRIORITY_TYPES,
    TASK_STATE_TYPES,
    TASK_TYPES,
    TASK_TAG_TYPES,
    TASK_COMMENT_TYPES
  )

export { store, TYPES }
